import Action from '../../../Action'
import './styles/ImportInfo.css'
import { useState ,useEffect,useRef } from 'react';
import LoadSimple from '../../../LoadSimple';
import { capitalizeFirstLetter } from '../../../../utils/utils';
import { lang } from '../../../generales/traduction';
const ModalMsgGruposTelegram =({buscar_cis,closeMsgModal,handleShowPopup,server,languaje,mode,importLoading,closeImportModal,setImportLoading,user})=>{
    const [file, setFile] = useState(null);
    const [disabled,setDisabled]=useState(true)
    const [msgError,setMsgError]=useState("")
    const [boolError,setBoolError]=useState(false)
    const [response,setResponse]=useState([])
    const [loading,setLoading]=useState(false)
    const [dataGroups,setDataGroups]=useState([])

    const fileInputRef = useRef(null);




    // Función para leer el archivo
    const send_message=()=>{
      
      
      let method='POST'
      
      
    
      
      
      
      setLoading(true)
        setTimeout(()=>{
          setLoading(false)
              // Manejo de la respuesta
            
          
              handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(lang[languaje]['sendMsgCorrect']),'', true)
              // console.log(data1);
              closeMsgModal()
           
        },1000)
      
        const fetchDataPost = async () => {
          const body={
              "groupid": user.groupid,
              "mensaje": msgError
          }
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/media/telegram/send_message', {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(body),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
           
         
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(lang[languaje]['sendMsgCorrect']),'', true)
             // console.log(data1);
             closeMsgModal()
          
         
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['sendMsgIncorrect']),data1.detail, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              
              
          setLoading(false)
            
            // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
           
            console.error(error);
          }
        };
    
        // fetchDataPost();
        
  }
    // const [textArea,setTextArea]=useState("")
    const handleTextAreaChange = (event) => {
        if(event.target.value!="" && phone!=""){
            setDisabled(false)
        }else{
            setDisabled(true)
        }
        setMsgError(event.target.value)
        // setDisabled(false)
        // console.log(event.target.value)
        // setTextArea(event.target.value)
        // (msgError!="")?setDisabled(false):setDisabled(true)
       
      };
    const [phone,setPhone]=useState('')
    const handleChange=(e)=>{
        if(msgError!="" && phone!=""){
            setDisabled(false)
        }else{
            setDisabled(true)
        }
        const {name,value}=e.target
        setPhone(value)
    }
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {'Unirse'}
                    </div>
                </div>
                <div className='content-card-modal-gs' >
                
                    <div className="cont-import-GS-box"> 
                        <div className='row-cont-input-file instructions' style={{height:'25%',display:'block'}}>
                            <div className='rowInstructions titleInstructions' style={{position:'relative'}}>{'Se solicitara unirse al grupo'}: </div>
                            <div className='rowInstructions' style={{height:'30%'}}>{'Group ID: '+user.id} </div>
                            <div className='rowInstructions' style={{height:'30%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])+": "+user.name} </div>
                               <div className='rowInstructions ' style={{position:'relative'}}>{'Ingrese el numero de telefono con el que se agregara al grupo'}: </div>
                        </div>
                        <div className='row-cont-input-table' >
                        
                            
                                    <div className="form-GS-box" style={{width:'100%'}}> 
                                    
                                    <div className="user-box-GS"  style={{height:'30%'}}>
                                    <input required name="name"  type="text" value={phone}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{'Telefono'}</label>
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'70%'}}>
                                        {/* <input required name="name"  type="textarea"  onChange={handleTextAreaChange} value={textArea} 
                                    /> */}
                                     <textarea id="comentarios" className='txtAreaGS' name="comentarios" onChange={handleTextAreaChange} placeholder={capitalizeFirstLetter(lang[languaje]['txtAreaMsg'])}></textarea>
                                        <label className='label-GS' style={{top:'0%'}}> {capitalizeFirstLetter(lang[languaje]['mensaje'])}</label>
                                        
                                        
                                    </div>
                                    
                                    
                                </div>
                            

        
                        
                        </div>
                        <div className='row-cont-input-buttons'>
                        {(loading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%',width:'100%'}}><LoadSimple></LoadSimple></div>:
                        (
                        <>
                        <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(((response.length==0)?lang[languaje]['cancelar']:lang[languaje]['cerrar']))}  action={closeMsgModal}/>
                        <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['enviar'])}  action={send_message}/>
                        </>
                        )
                        }
                        </div>           
                    </div>
                </div>
                </div>
        </div>
    )
}

export default ModalMsgGruposTelegram